module.exports = __webpack_public_path__ + "img/feature-tile-icon-05.b4bf7d2b.svg";